/**
 * Types for the read-only "3rd level bids - Review" Data Editing page (feature 017).
 * The page reviews the same hands as feature 013, filtered to one of three categories and
 * ordered ascending by id. It reuses the practice `Problem` wire shape (the review endpoint
 * returns the same item DTO), so no new item type is needed here.
 */

/** The three review data categories. The wire value is the lowercase-hyphen form. */
export type ThirdLevelBidReviewCategory = 'incorrect-jim' | 'all' | 'hands-with-comments';

/** Default selection on page load (FR-010): the hands Jim answered incorrectly. */
export const DEFAULT_REVIEW_CATEGORY: ThirdLevelBidReviewCategory = 'incorrect-jim';

/** Human-readable labels for the data-category dropdown (FR-010). */
export const THIRD_LEVEL_REVIEW_CATEGORY_LABELS: Record<ThirdLevelBidReviewCategory, string> = {
  'incorrect-jim': 'Incorrect answers - Jim',
  all: 'All',
  'hands-with-comments': 'Hands with comments',
};

/** Dropdown order (FR-010): All, Incorrect answers - Jim, then Hands with comments (appended last). */
export const THIRD_LEVEL_REVIEW_CATEGORIES: ThirdLevelBidReviewCategory[] = [
  'all',
  'incorrect-jim',
  'hands-with-comments',
];
